import { ROLES, normalizeRole } from "../auth/access";

function safeText(value) {
   return String(value ?? "").trim();
}

export function isStaffRole(role) {
   const r = normalizeRole(role);
   return r === ROLES.ADMIN || r === ROLES.MANAGER;
}

export function isStaffMessage(message) {
   const role = safeText(message?.senderRole).toUpperCase();
   return role === "MANAGER" || role === "ADMIN";
}

export function isStudentMessage(message) {
   const role = safeText(message?.senderRole).toUpperCase();
   return role === "STUDENT" || role === "USER";
}

export function chatToastId(item) {
   if (item?.messageId != null) return `chat-${item.messageId}`;
   return "";
}

export function readStudentName(student) {
   const first = safeText(student?.firstName);
   const last = safeText(student?.lastName);
   const full = `${first} ${last}`.trim();
   return full || safeText(student?.email) || "Student";
}

export function formatChatToastTime(value) {
   if (!value) return "";
   const d = new Date(value);
   if (Number.isNaN(d.getTime())) return "";
   return d.toLocaleString("ro-RO", {
      hour: "2-digit",
      minute: "2-digit",
   });
}

export function buildChatToastItem(message, { user, conversationById }) {
   const staff = isStaffRole(user?.role);

   if (staff) {
      const conv = conversationById?.get(String(message.conversationId));
      return {
         kind: "chat",
         messageId: message.id,
         conversationId: message.conversationId,
         title:
            safeText(message.senderName) ||
            readStudentName(conv?.student) ||
            "Student",
         body: safeText(message.body),
         createdAt: message.createdAt,
         student: conv?.student ?? null,
      };
   }

   return {
      kind: "chat",
      messageId: message.id,
      conversationId: message.conversationId,
      title: "Instruire Auto a răspuns",
      body: safeText(message.body),
      createdAt: message.createdAt,
      student: null,
   };
}

export function isIncomingChatToastMessage(message, user) {
   if (!message?.id) return false;
   if (isStaffRole(user?.role)) return isStudentMessage(message);
   return isStaffMessage(message);
}
